//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";

const positionValidator = value => {
    const parts = value.split(" ");
    if (parts.length !== 2) {
        return false;
    }
    if (!["top", "center", "bottom"].includes(parts[0])) {
        console.error("Anchor/Self position must start with one of top/center/bottom");
        return false;
    }
    if (!["left", "middle", "right"].includes(parts[1])) {
        console.error("Anchor/Self position must end with one of left/middle/right");
        return false;
    }
    return true;
};

export default {
    name: "AQDropdown",
    components: {
        AQMenu,
        AQAvatar,
        AQChip,
        AQTooltip,
        AQBadge
    },
    props: {
        // AQMenu props:
        /*
         exemple [{ label: '', value: '', avatarProps: {type, isDisabled, isEditable}, leftIcon: {name: "edit", size: '16px'},
         tooltip: {tooltipContent, direction} }]
         avatar,badge,chip, tooltip, leftIcon, rightIcon, is an Object with there specific props
         if you want the item from within the menu to be disabled, send inside the options object itemDisabled: true
         if you want a description/sub-label send in the options object description: "string"
        */
        options: {
            type: Array,
            required: true,
            default: () => []
        },
        readonly: { type: Boolean, default: false },
        addSearch: { type: Boolean, default: false }, // show search field in options container
        disable: { type: Boolean, default: false }, // disable popover (popover won`t be opened)
        fitParentContainer: { type: Boolean, default: false }, // options container width = parent width
        hasAvatar: { type: Boolean, default: false }, // show AQAvatar on the left side - option
        resetSelectedData: { type: Boolean, default: false }, // reset selected option (s)
        hasCheckbox: { type: Boolean, default: false }, // show checkbox
        separator: { type: Boolean, default: false }, // separator line between items
        error: { type: Boolean, default: false }, // set error border
        isMultiselect: { type: Boolean, default: false }, // enable multiple selection
        keepClosed: { type: Boolean, default: false }, // ddl won't open at click

        // AQDropdownProps:
        value: { type: null },
        defaultValue: { type: [String, Boolean, Number, Array], default: "" },
        rounded: { type: Boolean, default: false }, // dropdown rounded corners ( no corners)
        avatarRounded: { type: Boolean, default: true }, // if avatar exist in options
        clearable: { type: Boolean, default: false },
        isDisabledUser: { type: Boolean, default: false }, // used to gray out disabled users - visual pov
        clearableChip: { type: Boolean, default: false }, // if you need the chip that form in the dropdown to be clearable send clearableChip prop
        placeholder: { type: String, default: "" }, // AQDropdown - placeholder
        errorLabel: { type: String, default: "" },
        label: { type: String, default: "" }, // AQDropdown - label
        hasPagination: { type: Boolean, default: false },
        hasNormalState: { type: Boolean, default: false }, // prop used for disable state, to look normal, but disabled
        conditionalDDL: { type: Boolean, default: false },
        sendAllData: { type: Boolean, default: false },
        popoverAnchorPosition: { type: String, validator: positionValidator }, // prop used for anchor popover position
        popoverSelfPosition: { type: String, validator: positionValidator }, // prop used for self popover position
        noBorder: { type: Boolean, default: false },
        zIndex: { type: Number, default: 9999 }, // use this prop with the desired value if the menu is displayed under another element
        expandIcon: { type: Boolean, default: true },
        emitValue: { type: Boolean, default: false },
        updateValue: { type: Boolean, default: false },
        forceUpdateValue: { type: Boolean, default: false },
        hasRightIcon: { type: Object, default: () => {} }, // used only for the input section,
        hasRightIconTooltip: { type: String, default: "" }, // used only in pair with hasRightIcon
        disabledOptionsList: { type: Array, default: () => [] }, // disable options in menu, ex: ["value", "value1", . . . ]
        persistentMenuOps: { type: Boolean, default: false }
    },
    data() {
        return {
            hasClear: false,
            chipDeleted: false,
            isInnerChip: null,
            isSelect: false,
            isDeselect: false,
            hasError: false,
            firstOptionsLoaded: false,
            newRoundChip: {},
            filtredDisplayMultipleSelected: [],
            displayedChips: 0,
            roundChip: 0,
            menuValues: [],
            innerMenuValues: [],
            innerMenuOptions: [],
            displayMultipleSelected: [],
            selectedValue: [],
            openedOptions: false,
            filteredItems: [],
            multipleSelectedElements: [],
            isOpenedInnerMenu: false,
            isOpened: false,
            valueFirstLoaded: true,
            showBullet: false,
            selectedRightIconColor: null,
            menuMinWidth: "",
            menuMaxWidth: "",
            itemSelected: false
        };
    },
    computed: {
        computedSelectedValue() {
            if (!this.isMultiselect) {
                return this.selectedValue;
            }
            return [];
        },
        innerMenuProps() {
            return {
                innerMenu: true,
                options: this.innerMenuOptions,
                fitParentContainer: this.fitParentContainer,
                isMultiselect: this.isMultiselect,
                error: this.hasError,
                separator: this.separator,
                disable: this.disable || this.readonly || this.keepClosed,
                avatarRounded: this.avatarRounded,
                resetSelectedData: this.resetSelectedData,
                addSearch: this.addSearch,
                hasCheckbox: this.hasCheckbox,
                clearableChip: this.clearableChip
            };
        },
        menuProps() {
            return {
                hasAvatar: this.hasAvatar,
                options: this.options,
                fitParentContainer: this.fitParentContainer,
                isMultiselect: this.isMultiselect,
                error: this.hasError,
                separator: this.separator,
                disable: this.disable || this.readonly || this.keepClosed,
                avatarRounded: this.avatarRounded,
                resetSelectedData: this.resetSelectedData,
                addSearch: this.addSearch,
                hasCheckbox: this.hasCheckbox,
                hasPagination: this.hasPagination,
                conditionalDDL: this.conditionalDDL,
                chipDeleted: this.chipDeleted,
                popoverAnchorPosition: this.popoverAnchorPosition,
                popoverSelfPosition: this.popoverSelfPosition,
                minWidth: this.menuMinWidth,
                maxWidth: this.menuMaxWidth,
                zIndex: this.zIndex,
                keepOneOptionSelected: true,
                isDisabledUser: this.isDisabledUser,
                fromDropdown: true,
                disabledOptionsList: this.disabledOptionsList || [],
                persistent: this.persistentMenuOps
            };
        },
        isClearable() {
            return this.clearable && this.selectedValue && this.selectedValue.length;
        }
    },
    watch: {
        value: {
            handler(newV, oldV) {
                // set default values on v-model
                if (!this.defaultValue && (this.isMultiselect || this.updateValue || !oldV)) {
                    if (newV && newV.length) {
                        this.menuValues = newV;
                        this.displayedChips = newV.length;
                    }
                }
            },
            immediate: true
        },
        // ToDo: rewrite method for more generic purpose
        defaultValue: {
            handler(newVal) {
                if (newVal && typeof newVal !== "boolean" && this.options.length && (!this.selectedValue.length || this.forceUpdateValue)) {
                    this.setDefaultValue(newVal);
                } else if (newVal === null) { // reset dropdown if send null value
                    this.clearValue();
                } else if (typeof newVal === "boolean" && this.options.length) {
                    this.setDefaultValue(newVal);
                }
            },
            immediate: true
        },
        error: {
            handler(newValue) {
                this.hasError = newValue;
            },
            immediate: true
        },
        roundChip: {
            handler(newV, oldV) {
                // enter here and set chips on first selection & on default value v-model
                if (newV && oldV === 0) {
                    this.setChipValues("first");
                    // enter here on every other chip after the first one and increment round chip
                } else if (newV && newV > oldV && !(this.isSelect || this.isDeselect)) {
                    this.setChipValues("isRound");
                }
            }
        },
        menuValues: {
            handler(newVal, oldValue) {
                if (newVal && newVal.length) {
                    if (this.isMultiselect) {
                        if (this.isDeselect) {
                            if (newVal.length > oldValue.length) {
                                this.isDeselect = false;
                            } else {
                                this.emitInputValue(newVal);
                                this.itemSelected = false;
                                return;
                            }
                        } else if (!this.itemSelected) {
                            if (this.filtredDisplayMultipleSelected && this.filtredDisplayMultipleSelected.length) {
                                this.roundChip = 0;
                                this.selectedValue = [];
                                this.innerMenuOptions = [];
                                this.multipleSelectedElements = [];
                                this.filtredDisplayMultipleSelected = [];
                            }
                            this.displayMultipleSelected = JSON.parse(JSON.stringify(newVal));
                            this.filtredDisplayMultipleSelected = JSON.parse(JSON.stringify(newVal));
                            this.selectedValue = newVal;
                            this.itemSelected = false;
                            return;
                        }
                        if (oldValue && oldValue.length === newVal.length && this.$refs.innerChipMenu && this.isInnerChip) {
                            // close and open popover when delete innnerChip so the popover stays in the same position
                            this.$refs.innerChipMenu.$refs.popoverCustomSelect.hide();
                            this.$refs.innerChipMenu.$refs.popoverCustomSelect.show();
                            this.itemSelected = false;
                            return;
                        }
                    }
                    if (!this.roundChip) {
                        this.filtredDisplayMultipleSelected = JSON.parse(JSON.stringify(newVal));
                    } else if (this.roundChip && !this.isMultiselect) {
                        this.roundChip = 0;
                    }
                    if (this.isMultiselect && oldValue && newVal.length < oldValue.length) {
                        this.displayedChips--;
                    } else if (this.isMultiselect && oldValue && oldValue.length && newVal.length > oldValue.length && !this.roundChip && this.itemSelected) {
                        this.displayedChips++;
                        this.filtredDisplayMultipleSelected = JSON.parse(JSON.stringify(newVal));
                    }
                    this.displayMultipleSelected = JSON.parse(JSON.stringify(newVal));
                    this.selectedValue = newVal;
                    this.emitInputValue(newVal);
                } else {
                    this.selectedValue = [];
                    this.displayMultipleSelected = [];
                    this.filtredDisplayMultipleSelected = [];
                    this.firstOptionsLoaded = false;
                    this.emitInputValue([]);
                }
                this.itemSelected = false;
            },
            deep: true,
            immediate: true
        },
        options: {
            handler(newValue) {
                if (newValue && newValue.length) {
                    if ((!this.selectedValue.length && this.defaultValue) || typeof this.defaultValue === "boolean") {
                        this.setDefaultValue(this.defaultValue);
                    }
                }
            },
            immediate: true
        },
        selectOptions: {
            handler() {
                if (!this.valueFirstLoaded) {
                    this.setNewSelectedOptions();
                }
            }
        },
        resetSelectedData: {
            handler(val) {
                if (val) {
                    this.clearValue();
                }
            }
        }
    },
    updated() {
        this.isDeselect = false;
        this.isSelect = false;
        this.chipDeleted = false;
    },
    methods: {
        setDefaultValue(newVal) {
            if (!this.isMultiselect) {
                this.selectedValue = [];
                this.menuValues = [];
            }
            if (Array.isArray(newVal)) {
                const newValues = [];
                this.options.forEach(elem => {
                    if (newVal.includes(elem.value)) {
                        newValues.push(elem);
                    }
                });
                if (newValues.length) {
                    this.menuValues = newValues;
                    this.selectedValue = newValues;
                    this.emitInputValue(newValues);
                    this.displayedChips = newVal.length;
                }
            } else if (!this.selectedValue.length && this.options && this.options.length) {
                const fistSelectedValue = this.options.find(elem => elem.value === newVal);
                if (fistSelectedValue) {
                    this.menuValues.push(fistSelectedValue);
                    this.selectedValue.push(fistSelectedValue);
                    this.emitInputValue([fistSelectedValue]);
                }
            }
        },
        /*
        emit input model cases
        case: multi select
        if has emitValue prop will emit and array of values,
        else will send and array of objects with all the properties sent (as before)

        case: single select
        if has emitValue prop will emit the value as string,
        else will emit the value as object with all the properties sent (as before)
        */
        emitInputValue(data) {
            if (data && data.length) {
                if (this.isMultiselect) {
                    if (this.emitValue) {
                        const valueArray = [];
                        for (let i = 0; i < data.length; i++) {
                            valueArray.push(data[i].value);
                        }
                        this.$emit("input", valueArray);
                        this.$emit("selected", valueArray);
                    } else {
                        this.$emit("input", data);
                        this.$emit("selected", data);
                    }
                } else if (this.emitValue) {
                    this.$emit("input", data[0].value);
                    this.$emit("selected", data[0].value);
                } else {
                    this.$emit("input", data);
                    this.$emit("selected", data);
                }
            } else if ((!data || Array.isArray(data)) && this.hasClear) {
                if (this.isMultiselect) {
                    this.$emit("input", []);
                    this.$emit("selected", []);
                } else if (this.emitValue) {
                    this.$emit("input", "");
                    this.$emit("selected", "");
                } else {
                    this.$emit("input", []);
                    this.$emit("selected", []);
                }
            }
        },
        onChange(evt) {
            this.stopCheck(evt);
            this.itemSelected = true;
            if (this.isMultiselect) {
                if (evt && !evt.length) {
                    this.hasClear = true;
                }
                if (this.emitValue) {
                    const valueArray = [];
                    for (let i = 0; i < evt.length; i++) {
                        valueArray.push(evt[i].value);
                    }
                    this.$emit("onChange", valueArray);
                } else {
                    this.$emit("onChange", evt);
                }
            } else if (this.emitValue) {
                this.$emit("onChange", evt[0].value);
            } else {
                this.$emit("onChange", evt);
            }
            this.stopCheck(evt);
        },
        refreshChipList(item) {
            if (this.displayMultipleSelected.length === 1 && this.displayMultipleSelected.find(elem => elem.label === item.label)) {
                this.displayedChips--;
            }
            this.setChipValues("deSelect", item);
        },
        chipClicked(evt) {
            evt.event.stopPropagation();
            if (this.$refs.menuDropdown) {
                this.$refs.menuDropdown.$refs.popoverCustomSelect.hide();
            }
            setTimeout(() => {
                if (this.$refs.innerChipMenu) {
                    if (this.isOpenedInnerMenu) {
                        this.$refs.innerChipMenu.$refs.popoverCustomSelect.hide();
                    } else {
                        this.$refs.innerChipMenu.$refs.popoverCustomSelect.show();
                    }
                }
            }, 0);
        },
        // another method to check round chip on change event
        checkOnDefaultMultiselect() {
            if (!this.isSelect) {
                if (this.isMultiselect) {
                    const removeWidth = this.clearableChip ? 70 : 50;
                    const addWidth = this.$refs.innerChipContainer ? this.$refs.innerChipContainer.offsetWidth : 0;
                    if (
                        this.$refs.chipContainer
                        && this.$refs.selectedContainer
                        && this.$refs.chipContainer.offsetWidth + addWidth > this.$refs.selectedContainer.offsetWidth - removeWidth
                    ) {
                        this.roundChip++;
                        this.displayedChips--;
                    }
                }
            }
        },
        stopCheck(item) {
            this.isSelect = true;
            if (this.roundChip && !this.isDeselect) {
                const newAddedItem = item.pop();
                const found = this.innerMenuOptions.find(el => el.label === newAddedItem.label);
                if (!found) {
                    this.innerMenuOptions.push(newAddedItem);
                    this.roundChip++;
                }
                this.menuValues.push(newAddedItem);
            } else if (!this.roundChip) {
                this.checkIfRoundChip("onSelection");
            }
        },
        // method to check if round chip on different events
        checkIfRoundChip(evt, i) {
            if ((this.isMultiselect && i === this.displayedChips - 1) || evt === "onSelection") {
                const removeWidth = this.clearableChip ? 70 : 50;
                if (
                    !this.roundChip
                    && this.$refs.chipContainer
                    && this.$refs.selectedContainer
                    && this.$refs.chipContainer.offsetWidth > this.$refs.selectedContainer.offsetWidth - removeWidth
                ) {
                    this.roundChip++;
                } else if (this.roundChip) {
                    this.roundChip++;
                }
            }
        },
        sendSearchValue(value) {
            this.$emit("searchValueDD", value);
        },
        setChipValues(evt, i) {
            if (evt === "mounted") {
                this.checkIfRoundChip(evt, i);
            }
            if (evt === "deSelect") {
                this.isDeselect = true;
                this.removeChipFromLists(i);
            } else if (!this.firstOptionsLoaded && !evt) {
                this.filtredDisplayMultipleSelected = JSON.parse(JSON.stringify(this.displayMultipleSelected));
                this.firstOptionsLoaded = true;
            } else if (evt === "first") {
                if (!this.isMultiselect) {
                    this.innerMenuOptions = [];
                }
                if (this.filtredDisplayMultipleSelected && this.filtredDisplayMultipleSelected.length > 1) {
                    this.newRoundChip = this.filtredDisplayMultipleSelected.pop();
                }
                if (this.newRoundChip && Object.keys(this.newRoundChip).length) {
                    this.innerMenuOptions.push(this.newRoundChip);
                }
                if (!this.isMultiselect) {
                    this.innerMenuOptions = [];
                }
            } else if (evt === "isRound" && this.isMultiselect) {
                this.newRoundChip = this.filtredDisplayMultipleSelected.pop();
                if (this.newRoundChip) {
                    this.innerMenuOptions.push(this.newRoundChip);
                }
            }
        },
        setChipType(item) {
            let type = "default";
            if (item && item.avatarProps) {
                if (
                    item.avatarProps.type === "system"
                    || item.avatarProps.type === "platform"
                    || item.avatarProps.type === "applicationSpecific"
                    || item.avatarProps.type === "externalGroup"
                ) {
                    type = "group";
                } else {
                    type = "user";
                }
            }
            return type;
        },
        propsForAvatar(item) {
            return {
                type: item.avatarProps.type || "userPlatform",
                isEditable: item.avatarProps.isEditable || item.isEditable || false,
                customAvatar: item.avatarProps.customAvatar || "",
                rounded: this.avatarRounded,
                avatarDisabled: item.avatarProps.avatarDisabled || false,
                hasUserNotification: item.hasUserNotification || false,
                size: item.avatarProps.size < 25 ? item.avatarProps.size : 24
            };
        },
        propsForBadge(item) {
            return {
                badgeText: item.badgeProps.badgeText || "",
                badgeColor: item.badgeProps.badgeColor || "",
                badgeType: item.badgeProps.badgeType || "string",
                fontSize: item.badgeProps.fontSize || 10
            };
        },
        propsForChip(item) {
            return {
                type: item.chipProps.type || "default",
                content: item.chipProps.content || null,
                innerContent: item.chipProps.innerContent || ""
            };
        },
        removeChipFromLists(item, deleteChip, isInnerChip) {
            this.isInnerChip = isInnerChip;
            let found = false;
            this.isDeselect = true;
            if (this.innerMenuOptions && this.innerMenuOptions.length) {
                // case when delete the chip from the dropdown
                if (deleteChip) {
                    if (this.isMultiselect) {
                        if (item.includes("+")) {
                            this.innerMenuOptions.forEach(elem => {
                                this.menuValues.forEach((menuItem, i) => {
                                    if (menuItem.label === elem.label) {
                                        this.menuValues.splice(i, 1);
                                    }
                                });
                            });
                            this.displayedChips -= this.innerMenuOptions.length + this.filtredDisplayMultipleSelected.length;
                            this.roundChip = this.displayedChips;
                            this.innerMenuOptions = [];
                            this.found = true;
                        }
                    } else {
                        this.displayedChips -= this.innerMenuOptions.length + this.filtredDisplayMultipleSelected.length;
                        this.roundChip = this.displayedChips;
                        this.innerMenuOptions = [];
                        this.found = true;
                    }
                    // case when delete the chip from innerMenu
                } else if (isInnerChip) {
                    for (let idx = 0; idx < this.innerMenuOptions.length; idx++) {
                        if (this.innerMenuOptions[idx].label === item) {
                            this.innerMenuOptions.splice(idx, 1);
                            if (!this.innerMenuOptions.length) {
                                this.isOpenedInnerMenu = false;
                            }
                            this.roundChip--;
                            found = true;
                            break;
                        }
                    }
                    for (let idx = 0; idx < this.menuValues.length; idx++) {
                        if (this.menuValues[idx].label === item) {
                            this.menuValues.splice(idx, 1);
                            found = true;
                            break;
                        }
                    }
                    // case when remove a selected option from the menu (deselect)
                } else {
                    for (let idx = 0; idx < this.innerMenuOptions.length; idx++) {
                        if (this.innerMenuOptions[idx].label === item.label) {
                            this.innerMenuOptions.splice(idx, 1);
                            this.roundChip--;
                            found = true;
                            break;
                        }
                    }
                    for (let idx = 0; idx < this.menuValues.length; idx++) {
                        if (this.menuValues[idx].label === item) {
                            this.menuValues.splice(idx, 1);
                            found = true;
                            break;
                        }
                    }
                }
            }
            if (!found) {
                for (let idx = 0; idx < this.filtredDisplayMultipleSelected.length; idx++) {
                    if (deleteChip && this.filtredDisplayMultipleSelected[idx].label === item) {
                        this.filtredDisplayMultipleSelected.splice(idx, 1);
                        this.menuValues.splice(idx, 1);
                        if (!this.menuValues.length) {
                            this.hasClear = true;
                        }
                        this.isDeselect = true;
                        found = true;
                        break;
                    } else if (this.filtredDisplayMultipleSelected[idx].label === item.label) {
                        this.filtredDisplayMultipleSelected.splice(idx, 1);
                        found = true;
                        break;
                    }
                }
            }
            let valuesToEmit = [];
            if (!this.sendAllData) {
                valuesToEmit = this.menuValues.map(elem => elem.value);
            }
            this.$emit("onChange", this.sendAllData ? this.menuValues : valuesToEmit);
        },
        deleteChip(evt, isInnerChip) {
            if (this.disable || this.readonly) {
                evt.event.stopPropagation();
            } else {
                evt.event.stopPropagation();
                if (isInnerChip) {
                    this.removeChipFromLists(evt.content, false, isInnerChip); // delete chip from innerMenu
                    this.$emit("deleteInnerChip");
                } else {
                    this.removeChipFromLists(evt.content, true); // delete chip from dropdown
                    this.$emit("deleteChip");
                }
                this.chipDeleted = true;
                this.$emit("deleteChip", evt);
            }
        },
        setNewSelectedOptions() {
            if (Array.isArray(this.selectOptions)) {
                this.multipleSelectedElements = [];
                this.selectOptions.forEach(i => {
                    const elem = this.filteredItems.find(item => item.value === i);
                    if (elem) {
                        this.multipleSelectedElements.push(elem);
                    }
                });
            } else {
                this.multipleSelectedElements = this.filteredItems.filter(item => item.value === this.selectOptions);
            }
            if (this.multipleSelectedElements[0] && this.multipleSelectedElements[0].rightIcon) {
                this.showBullet = true;
                this.selectedRightIconColor = this.multipleSelectedElements[0].color;
            } else {
                this.showBullet = false;
            }
            if (this.multipleSelectedElements[0]) {
                if (this.useTranslate) {
                    this.selectedValue = this.useTranslate ? this.$t(this.multipleSelectedElements[0].label) : this.multipleSelectedElements[0].label;
                }
            }

            this.valueFirstLoaded = false;
        },
        clickDropdown() {
            if (this.$refs.selectedContainer && this.$refs.selectedContainer.offsetWidth) {
                const parentWidth = this.$refs.selectedContainer.offsetWidth;
                this.menuMinWidth = `${parentWidth}px`;
                this.menuMaxWidth = parentWidth > 250 ? `${parentWidth}px` : "250px";
            }
        },
        toggleMenu(opened) {
            this.openedOptions = opened;
            this.isOpened = opened;
            if (opened) {
                this.$emit("show");
            } else {
                this.$emit("hide");
            }
        },
        toggleInnerMenu(opened) {
            this.isOpenedInnerMenu = opened;
        },
        clearValue(fromXClick) {
            this.hasClear = true;
            this.menuValues = [];
            this.roundChip = 0;
            this.displayedChips = 0;
            this.selectedValue = [];
            this.innerMenuOptions = [];
            this.multipleSelectedElements = [];
            this.emitInputValue([]);
            this.$emit("clear");
            if (fromXClick) {
                this.$emit("clearClicked");
            }
        }
    }
};
